// Process taxonomy mirroring backend app/core/taxonomy.py
// Keep in sync with PROCESSES and PROCESS_COLORS on the backend.

export interface ProcessEntry {
  code: string
  name: string
  short: string
  color: string
}

export const PROCESSES: Record<string, ProcessEntry> = {
  GEO: { code: 'GEO', name: 'Геологоразведка', short: 'Геология', color: '#a78bfa' },
  MINEPLAN: { code: 'MINEPLAN', name: 'Горное планирование', short: 'Планирование', color: '#60a5fa' },
  DRILLBLAST: { code: 'DRILLBLAST', name: 'Буровзрывные работы', short: 'БВР', color: '#fb923c' },
  MINING: { code: 'MINING', name: 'Добыча', short: 'Добыча', color: '#f59e0b' },
  TRANSPORT: { code: 'TRANSPORT', name: 'Транспорт', short: 'Транспорт', color: '#06b6d4' },
  PROCESS: { code: 'PROCESS', name: 'Обогащение', short: 'ОФ', color: '#10b981' },
  METALLURGY: { code: 'METALLURGY', name: 'Металлургия', short: 'Металлургия', color: '#eab308' },
  TAILINGS: { code: 'TAILINGS', name: 'Хвостовое хозяйство', short: 'Хвосты', color: '#0ea5e9' },
  MAINTENANCE: { code: 'MAINTENANCE', name: 'ТОиР', short: 'ТОиР', color: '#8b5cf6' },
  ENERGY: { code: 'ENERGY', name: 'Энергетика', short: 'Энергетика', color: '#f97316' },
  HSE: { code: 'HSE', name: 'Промбезопасность и ОТ', short: 'ОТиПБ', color: '#ef4444' },
  SUPPLY: { code: 'SUPPLY', name: 'Снабжение', short: 'Снабжение', color: '#84cc16' },
  MAINTGOLD: { code: 'MAINTGOLD', name: 'Учёт металла', short: 'Учёт металла', color: '#facc15' },
  HR: { code: 'HR', name: 'Персонал', short: 'HR', color: '#ec4899' },
  FIN: { code: 'FIN', name: 'Финансы', short: 'Финансы', color: '#22c55e' },
  IT: { code: 'IT', name: 'ИТ и АСУ ТП', short: 'IT', color: '#6366f1' },
  ADMIN: { code: 'ADMIN', name: 'Корпоративные функции', short: 'Админ', color: '#64748b' },
}

const FALLBACK_COLOR = '#71717a'

export function getProcessLabel(code: string): string {
  return PROCESSES[code]?.name ?? code
}

export function getProcessColor(code: string): string {
  return PROCESSES[code]?.color ?? FALLBACK_COLOR
}
